import { render, staticRenderFns } from "./TransportServicePricingForm.vue?vue&type=template&id=d4c373d2&"
import script from "./TransportServicePricingForm.vue?vue&type=script&lang=js&"
export * from "./TransportServicePricingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports